// @ts-nocheck
//import { functions } from "../utils/functions";
export default () => {

     const env_perc_step = 10; //Para 1% usar 100, 10% usar 10

     function filter_comb(numbers, filters, hist_list) {

          for (let i = 0; i < filters.length; i++) {

               let res_f = res_filter(numbers, filters[i], hist_list);
               if (res_f == false) {
                    return false;
               }
          }
          return true;
     }

     function res_filter(numbers, filter, hist_list) {

          let res = null;

          switch (filter.name) {
               case 'qtdSequencias':
                    res = qtdSequencias(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdSequenciaDiretaMax':
                    res = qtdSequenciaDiretaMax(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdNumPares':
                    res = qtdNumPares(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdFibonacci':
                    res = qtdFibonacci(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdNumPrimos':
                    res = qtdNumPrimos(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdLinhas':
                    res = qtdLinhas(numbers, filter.parameters.totNum);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdMaxLinha':
                    res = qtdMaxLinha(numbers, filter.parameters.totNum);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdColunas':
                    res = qtdColunas(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdMaxColuna':
                    res = qtdMaxColuna(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'distPrimUlt':
                    res = distPrimUlt(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'menorNum':
                    res = menorNum(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'maiorNum':
                    res = maiorNum(numbers);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdQuadEm4Quad':
                    res = qtdQuadEm4Quad(numbers, filter.parameters.totNum);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdMaxQuadEm4Quad':
                    res = qtdMaxQuadEm4Quad(numbers, filter.parameters.totNum);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               case 'qtdRepUltimo':
                    res = qtdRepUltimo(numbers, hist_list);
                    return (res >= filter.parameters.min && res <= filter.parameters.max) ? true : false
               default:
                    return true;
          }
     }

     function factorialize(num) {
          if (num < 0)
               return -1;
          else if (num == 0)
               return 1;
          else {
               return (num * factorialize(num - 1));
          }
     }

     function qtdSequencias(numbers) {
          let qtd_seq = 0;
          if (numbers.length > 1) {
               for (let i = 1; i < numbers.length; i++) {
                    if (numbers[i] == numbers[i - 1] + 1) {
                         qtd_seq++;
                    }
               }
          }
          return qtd_seq;
     }

     function qtdSequenciaDiretaMax(numbers) {
          let qtd_seq = 0;
          let qtd_seq_dir = 0;
          if (numbers.length > 1) {
               for (let i = 1; i < numbers.length; i++) {
                    if (numbers[i] == numbers[i - 1] + 1) {
                         qtd_seq++;
                    } else {
                         qtd_seq = 0;
                    }
                    if (qtd_seq > qtd_seq_dir) {
                         qtd_seq_dir = qtd_seq;
                    }
               }
          }
          return qtd_seq_dir;
     }

     function qtdNumPares(numbers) {
          let qtd_par = 0;
          for (let i = 0; i < numbers.length; i++) {
               if (numbers[i] % 2 == 0) {
                    qtd_par++;
               }
          }
          return qtd_par;
     }

     function qtdFibonacci(numbers) {
          let qtd = 0;
          let fibo = [1, 2, 3, 5, 8, 13, 21, 34, 55, 89]
          for (let i = 0; i < numbers.length; i++) {
               if (fibo.includes(numbers[i])) {
                    qtd++;
               }
          }
          return qtd;
     }

     function qtdNumPrimos(numbers) {
          let qtd = 0;
          let fibo = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97]
          for (let i = 0; i < numbers.length; i++) {
               if (fibo.includes(numbers[i])) {
                    qtd++;
               }
          }
          return qtd;
     }

     function qtdLinhas(numbers, totNum) {

          let qtd = 0;
          let linhas = parseInt(totNum / 10);
          if (totNum % 10 > 0) {
               linhas++;
          }

          let arr_qtd = [];
          for (let i = 0; i < linhas; i++) {
               arr_qtd[i] = 0
          }

          for (let i = 0; i < numbers.length; i++) {
               arr_qtd[parseInt((numbers[i] - 1) / 10)]++;
          }
          for (let i = 0; i < arr_qtd.length; i++) {
               if (arr_qtd[i] > 0) {
                    qtd++;
               }
          }
          return qtd;
     }

     function qtdMaxLinha(numbers, totNum) {

          let qtd = 0;
          let linhas = parseInt(totNum / 10);
          if (totNum % 10 > 0) {
               linhas++;
          }

          let arr_qtd = [];
          for (let i = 0; i < linhas; i++) {
               arr_qtd[i] = 0
          }

          for (let i = 0; i < numbers.length; i++) {
               arr_qtd[parseInt((numbers[i] - 1) / 10)]++;
          }
          for (let i = 0; i < arr_qtd.length; i++) {
               if (arr_qtd[i] > qtd) {
                    qtd = arr_qtd[i];
               }
          }
          return qtd;
     }

     function qtdColunas(numbers) {

          let qtd = 0;
          let arr_qtd = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          for (let i = 0; i < numbers.length; i++) {
               let aux = (numbers[i] % 10);
               arr_qtd[aux]++;
          }

          for (let i = 0; i < arr_qtd.length; i++) {
               if (arr_qtd[i] > 0) {
                    qtd++;
               }
          }
          return qtd;
     }

     function qtdMaxColuna(numbers) {

          let qtd = 0;
          let arr_qtd = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          for (let i = 0; i < numbers.length; i++) {
               let aux = (numbers[i] % 10);
               arr_qtd[aux]++;
          }

          for (let i = 0; i < arr_qtd.length; i++) {
               if (arr_qtd[i] > qtd) {
                    qtd = arr_qtd[i];
               }
          }
          return qtd;
     }

     function distPrimUlt(numbers) {

          let dist = 0;
          if (numbers.length > 1) {
               //dist = numbers[numbers.length - 1] - numbers[0];
               dist = Math.max(...numbers) - Math.min(...numbers);
          }
          return dist;
     }

     function menorNum(numbers) {
          return Math.min(...numbers);
     }

     function maiorNum(numbers) {
          return Math.max(...numbers);
     }

     function qtdQuadEm4Quad(numbers, totNum) {

          let qtd = 0;
          let metade = parseInt((totNum / 20)) - 1;

          let arr_quad = [0, 0, 0, 0];

          for (let i = 0; i < numbers.length; i++) {
               let final = numbers[i] % 10;
               let linha = parseInt((numbers[i] - 1) / 10);
               if (final >= 1 && final <= 5) {
                    if (linha > metade) {
                         arr_quad[2]++;
                    }
                    else {
                         arr_quad[0]++;
                    }
               }
               else {
                    if (linha > metade) {
                         arr_quad[3]++;
                    }
                    else {
                         arr_quad[1]++;
                    }
               }
          }
          for (let i = 0; i < arr_quad.length; i++) {
               if (arr_quad[i] > 0) {
                    qtd++;
               }
          }
          return qtd;
     }

     function qtdMaxQuadEm4Quad(numbers, totNum) {

          let qtd = 0;
          let metade = parseInt((totNum / 20)) - 1;

          let arr_quad = [0, 0, 0, 0];

          for (let i = 0; i < numbers.length; i++) {
               let final = numbers[i] % 10;
               let linha = parseInt((numbers[i] - 1) / 10);
               if (final >= 1 && final <= 5) {
                    if (linha > metade) {
                         arr_quad[2]++;
                    }
                    else {
                         arr_quad[0]++;
                    }
               }
               else {
                    if (linha > metade) {
                         arr_quad[3]++;
                    }
                    else {
                         arr_quad[1]++;
                    }
               }
          }
          for (let i = 0; i < arr_quad.length; i++) {
               if (arr_quad[i] > qtd) {
                    qtd = arr_quad[i];
               }
          }
          return qtd;
     }

     function qtdRepUltimo(numbers, hist_list) {
          let qtd_rep = 0;
          let ult_res = hist_list[hist_list.length - 1];
          for (let i = 0; i < numbers.length; i++) {
               if (ult_res.includes(numbers[i])) {
                    qtd_rep++;
               }
          }
          return qtd_rep;
     }

     function qtdRepAnteriores(numbers, hist_list, idx, qtd_jogos) {
          let qtd_rep = 0;
          if (idx >= qtd_jogos) {

               for (let i = 0; i < numbers.length; i++) {
                    let rep = 0;
                    for (let j = idx - qtd_jogos; j < idx; j++) {
                         if (hist_list[j].includes(numbers[i])) {
                              rep++;
                         }
                    }
                    if (rep > 0) {
                         qtd_rep++;
                    }
               }
          }
          return qtd_rep;
     }

     self.addEventListener('message', e => { // eslint-disable-line no-restricted-globals
          if (!e) return;
          let { hist_list, max_num, num_sorteados } = e.data;

          let total_combin = factorialize(max_num) / (factorialize(max_num - num_sorteados) * factorialize(num_sorteados));
          let qtd_linhas_disp = parseInt(max_num / 10);
          if (max_num % 10 > 0) {
               qtd_linhas_disp++;
          }
          let qtd_colunas_disp = 10;

          //Por número
          let atraso = [];
          let intervalo_atraso = [];
          let vezes_saiu = [];
          let qtd_graf = 100;
          let intervalo_atraso_graf = [];

          //Por sorteio
          let sequencias = [];
          let sequencias_dire_max = [];//qtdSequenciaDiretaMax
          let num_pares = [];//qtdNumPares
          let qtd_fibonacci = [];//qtdFibonacci
          let qtd_primos = [];//qtdNumPrimos
          let qtd_linhas = [];//qtdLinhas
          let qtd_max_linhas = [];//qtdMaxLinha
          let qtd_colunas = [];//qtdColunas
          let qtd_max_colunas = [];//qtdMaxColuna

          let dis_prim_ultimo = [];//distPrimUlt
          let menor_num = [];//menorNum
          let maior_num = [];//maiorNum
          let qtd_quad_em_4_quad = [];//qtdQuadEm4Quad
          let qtd_max_quad_em_4_quad = [];//qtdMaxQuadEm4Quad
          let qtd_rep_ultimo = [];//qtdRepUltimo
          let qtd_rep_2_ultimo = [];//qtdRepUltimo
          let qtd_rep_3_ultimo = [];//qtdRepUltimo
          let qtd_rep_4_ultimo = [];//qtdRepUltimo
          let qtd_rep_5_ultimo = [];//qtdRepUltimo

          //Entre todos os números disponíveis
          for (let i = 0; i < max_num; i++) {
               atraso[i] = { "numero": i + 1, "atraso": 0 };
               intervalo_atraso[i] = { "numero": i + 1, "intervalo_atraso": [] };
               vezes_saiu[i] = { "numero": i + 1, "vezes_saiu": 0 };

               dis_prim_ultimo[i] = { "dis_prim_ultimo": i, "qtd": 0 };
               menor_num[i] = { "menor_num": i + 1, "qtd": 0 };
               maior_num[i] = { "maior_num": i + 1, "qtd": 0 };
          }

          //Entre os sorteados
          for (let i = 0; i <= num_sorteados; i++) {
               sequencias[i] = { "sequencias": i, "qtd": 0, "qtd_all": 0 };
               sequencias_dire_max[i] = { "sequencias_dire_max": i, "qtd": 0, "qtd_all": 0 };
               num_pares[i] = { "num_pares": i, "qtd": 0, "qtd_all": 0 };
               qtd_fibonacci[i] = { "qtd_fibonacci": i, "qtd": 0, "qtd_all": 0 };
               qtd_primos[i] = { "qtd_primos": i, "qtd": 0, "qtd_all": 0 };

               qtd_max_quad_em_4_quad[i] = { "qtd_max_quad_em_4_quad": i, "qtd": 0, "qtd_all": 0 };
               qtd_rep_ultimo[i] = { "qtd_rep_ultimo": i, "qtd": 0, "qtd_all": 0 };
               qtd_rep_2_ultimo[i] = { "qtd_rep_2_ultimo": i, "qtd": 0, "qtd_all": 0 };
               qtd_rep_3_ultimo[i] = { "qtd_rep_3_ultimo": i, "qtd": 0, "qtd_all": 0 };
               qtd_rep_4_ultimo[i] = { "qtd_rep_4_ultimo": i, "qtd": 0, "qtd_all": 0 };
               qtd_rep_5_ultimo[i] = { "qtd_rep_5_ultimo": i, "qtd": 0, "qtd_all": 0 };
               qtd_max_linhas[i] = { "qtd_max_linhas": i, "qtd": 0, "qtd_all": 0 };
               qtd_max_colunas[i] = { "qtd_max_colunas": i, "qtd": 0, "qtd_all": 0 };
          }

          //Entre as linhas
          for (let i = 0; i <= qtd_linhas_disp; i++) {
               qtd_linhas[i] = { "qtd_linhas": i, "qtd": 0, "qtd_all": 0 };
          }

          //Entre as colunas
          for (let i = 0; i <= qtd_colunas_disp; i++) {
               qtd_colunas[i] = { "qtd_colunas": i, "qtd": 0, "qtd_all": 0 };

          }

          //4 quadrantes
          qtd_quad_em_4_quad = [
               { "qtd_quad_em_4_quad": 1, "qtd": 0, "qtd_all": 0 },
               { "qtd_quad_em_4_quad": 2, "qtd": 0, "qtd_all": 0 },
               { "qtd_quad_em_4_quad": 3, "qtd": 0, "qtd_all": 0 },
               { "qtd_quad_em_4_quad": 4, "qtd": 0, "qtd_all": 0 }
          ]


          let atr_ant = [];
          for (let j = 0; j < atraso.length; j++) {
               atr_ant[j] = 0;
          }
          for (let i = 0; i < hist_list.length; i++) {

               //Atraso
               for (let j = 0; j < atraso.length; j++) {
                    atraso[j].atraso++;
               }
               for (let j = 0; j < hist_list[i].length; j++) {
                    intervalo_atraso[hist_list[i][j] - 1].intervalo_atraso.push(atraso[hist_list[i][j] - 1].atraso);
                    atraso[hist_list[i][j] - 1].atraso = 0;
               }

               //Atraso para gráfico     
               let atr = [];
               for (let j = 0; j < atraso.length; j++) {
                    atr[j] = atr_ant[j] + 1;
               }
               for (let j = 0; j < hist_list[i].length; j++) {
                    atr[hist_list[i][j] - 1] = 0;
               }
               for (let j = 0; j < atraso.length; j++) {
                    atr_ant[j] = atr[j];
               }
               if (hist_list.length < qtd_graf || (i >= hist_list.length - qtd_graf)) {
                    intervalo_atraso_graf.push(atr);
               }

               //Vezes que saiu
               for (let j = 0; j < hist_list[i].length; j++) {
                    vezes_saiu[hist_list[i][j] - 1].vezes_saiu++;
               }

               //Análises
               sequencias[qtdSequencias(hist_list[i])].qtd++;
               sequencias_dire_max[qtdSequenciaDiretaMax(hist_list[i])].qtd++;
               num_pares[qtdNumPares(hist_list[i])].qtd++;
               qtd_fibonacci[qtdFibonacci(hist_list[i])].qtd++;
               qtd_primos[qtdNumPrimos(hist_list[i])].qtd++;

               qtd_linhas[qtdLinhas(hist_list[i], max_num)].qtd++;
               qtd_max_linhas[qtdMaxLinha(hist_list[i], max_num)].qtd++;
               qtd_colunas[qtdColunas(hist_list[i])].qtd++;
               qtd_max_colunas[qtdMaxColuna(hist_list[i])].qtd++;

               menor_num[menorNum(hist_list[i]) - 1].qtd++;
               maior_num[maiorNum(hist_list[i]) - 1].qtd++;

               qtd_quad_em_4_quad[qtdQuadEm4Quad(hist_list[i], max_num) - 1].qtd++;
               qtd_max_quad_em_4_quad[qtdMaxQuadEm4Quad(hist_list[i], max_num) - 1].qtd++;
               //qtd_rep_ultimo[qtdRepUltimo(hist_list[i],hist_list)].qtd++;
               qtd_rep_ultimo[qtdRepAnteriores(hist_list[i], hist_list, i, 1)].qtd++;
               qtd_rep_2_ultimo[qtdRepAnteriores(hist_list[i], hist_list, i, 2)].qtd++;
               qtd_rep_3_ultimo[qtdRepAnteriores(hist_list[i], hist_list, i, 3)].qtd++;
               qtd_rep_4_ultimo[qtdRepAnteriores(hist_list[i], hist_list, i, 4)].qtd++;
               qtd_rep_5_ultimo[qtdRepAnteriores(hist_list[i], hist_list, i, 5)].qtd++;
          }

          //Quantidade geral
          let qtd_tot = max_num;
          let qtd_jogo = num_sorteados;

          let aux = qtd_jogo - 1;
          let aux_2 = qtd_jogo - 1;
          let comb = [];
          let comb_ant = [];
          let lista_final = [];

          //Primeira combinação
          for (let i = 0; i < qtd_jogo; i++) {
               comb[i] = i + 1;
               comb_ant[i] = i + 1;
          }

          //Quantidades all por function
          sequencias[qtdSequencias(comb)].qtd_all++;
          sequencias_dire_max[qtdSequenciaDiretaMax(comb)].qtd_all++;
          num_pares[qtdNumPares(comb)].qtd_all++;
          qtd_fibonacci[qtdFibonacci(comb)].qtd_all++;
          qtd_primos[qtdNumPrimos(comb)].qtd_all++;
          qtd_linhas[qtdLinhas(comb, max_num)].qtd_all++;
          qtd_max_linhas[qtdMaxLinha(comb, max_num)].qtd_all++;
          qtd_colunas[qtdColunas(comb)].qtd_all++;
          qtd_max_colunas[qtdMaxColuna(comb)].qtd_all++;
          qtd_quad_em_4_quad[qtdQuadEm4Quad(comb, max_num) - 1].qtd_all++;
          qtd_max_quad_em_4_quad[qtdMaxQuadEm4Quad(comb, max_num) - 1].qtd_all++;

          //Verifica as demais combinações
          while (comb[0] <= (qtd_tot - qtd_jogo)) {
               comb = [];
               for (let i = 0; i < qtd_jogo; i++) {
                    comb[i] = comb_ant[i];
               }

               if (comb[aux_2] < qtd_tot) {
                    comb[aux_2]++;
               }
               else {
                    aux = qtd_jogo - 2;
                    while (comb[aux] == (qtd_tot - (qtd_jogo - aux - 1))) {
                         aux--;
                    }
                    comb[aux]++;
                    for (let i = aux + 1; i < qtd_jogo; i++) {
                         comb[i] = comb[i - 1] + 1;
                    }
               }

               for (let i = 0; i < qtd_jogo; i++) {
                    comb_ant[i] = comb[i];
               }
               sequencias[qtdSequencias(comb)].qtd_all++;
               sequencias_dire_max[qtdSequenciaDiretaMax(comb)].qtd_all++;
               num_pares[qtdNumPares(comb)].qtd_all++;
               qtd_fibonacci[qtdFibonacci(comb)].qtd_all++;
               qtd_primos[qtdNumPrimos(comb)].qtd_all++;
               qtd_linhas[qtdLinhas(comb, max_num)].qtd_all++;
               qtd_max_linhas[qtdMaxLinha(comb, max_num)].qtd_all++;
               qtd_colunas[qtdColunas(comb)].qtd_all++;
               qtd_max_colunas[qtdMaxColuna(comb)].qtd_all++;
               qtd_quad_em_4_quad[qtdQuadEm4Quad(comb, max_num) - 1].qtd_all++;
               qtd_max_quad_em_4_quad[qtdMaxQuadEm4Quad(comb, max_num) - 1].qtd_all++;

          }

          /*************** IA ***************/
          /*let qtd_jogos_hist = hist_list.length;
          let param = {
               "qtd_max_jogos_aprend": 50,
               "qtd_jogos_valid": 100,
               "max_num_result": 20,
               "qtd_tot_num_disp": max_num,
               "meta_acertos": 1,
               "meta_eficiencia": 0.05,
               "pesos_min": 0.01,
               "pesos_max": 1.0,
               "pesos_step": 0.01,
          };
          let param_aprend = {
               "ok": [
                    {
                         "type": "*",
                         "val": 1.01
                    },
                    {
                         "type": "=",
                         "val": 1.0
                    },
                    {
                         "type": "+",
                         "val": 0.01
                    },
                    {
                         "type": "-",
                         "val": 0.01
                    }
               ],
               "nok": [
                    {
                         "type": "*",
                         "val": 0.99
                    },
                    {
                         "type": "=",
                         "val": 0.02
                    },
                    {
                         "type": "-",
                         "val": 0.01
                    },
                    {
                         "type": "+",
                         "val": 0.05
                    }
               ]
          };

          let melhor_op = [];

          for (let j = 0; j <= num_sorteados; j++) {

               melhor_op.push({
                    "num_acert": j,
                    "options": []
               })

               for (let i = 0; i <= param.max_num_result; i++) {

                    melhor_op[j].options.push({
                         "qtd_num": i,
                         "eficiencia": 0,
                         "jogos_aprend": 0,
                         "ok": 0,
                         "nok": 0,
                         "p_ok": 0,
                         "p_nok": 0,
                         "p_cort": 0,
                         "p_cort_max" : 0
                    })
               }
          }


          for (let ok = 0; ok < param_aprend.ok.length; ok++) {

               console.log('ok', ok);

               for (let nok = 0; nok < param_aprend.nok.length; nok++) {

                    console.log('nok', nok);

                    for (let p_ok = param.pesos_min; p_ok <= param.pesos_max; p_ok += param.pesos_step) {

                         //console.log('p_ok',p_ok);

                         for (let p_nok = param.pesos_min; p_nok <= param.pesos_max; p_nok += param.pesos_step) {

                              //console.log('p_nok',p_nok);

                              for (let p_cort = param.pesos_min; p_cort <= param.pesos_max; p_cort += param.pesos_step) {

                                   for (let p_cort_max = param.pesos_step; p_cort_max <= param.pesos_max; p_cort_max += param.pesos_step) {

                                        //console.log('p_cort',p_cort);

                                        for (let i = 1; i <= param.qtd_max_jogos_aprend; i++) {

                                             let acertos_arr = [];

                                             for (let v = 0; v <= num_sorteados; v++) {
                                                  acertos_arr[v] = 0;
                                             }

                                             for (let v = 0; v < param.qtd_jogos_valid; v++) {

                                                  //Aprendizagem
                                                  let idx_ini_aprend = qtd_jogos_hist - param.qtd_jogos_valid - i + v;
                                                  let idx_fim_aprend = qtd_jogos_hist - param.qtd_jogos_valid - 1 + v;
                                                  let idx_valid = qtd_jogos_hist - param.qtd_jogos_valid + v;

                                                  //Valores iniciais
                                                  let pesos = [];
                                                  let ativos = [];
                                                  for (let p = 0; p < param.qtd_tot_num_disp; p++) {
                                                       pesos[p] = 1.0;
                                                  }

                                                  for (let j = idx_ini_aprend; j <= idx_fim_aprend; j++) {

                                                       for (let p = 0; p < param.qtd_tot_num_disp; p++) {
                                                            if (hist_list[j].includes(p + 1)) {

                                                                 //Acertou
                                                                 if (param_aprend.ok[ok].type == "=") {
                                                                      //pesos[p] = param_aprend.ok[ok].val;
                                                                      pesos[p] = p_ok;
                                                                 } else if (param_aprend.ok[ok].type == "*") {
                                                                      //pesos[p] *=  param_aprend.ok[ok].val;
                                                                      pesos[p] *= p_ok;
                                                                 } else if (param_aprend.ok[ok].type == "+") {
                                                                      //pesos[p] += param_aprend.ok[ok].val;
                                                                      pesos[p] += p_ok;
                                                                 } else if (param_aprend.ok[ok].type == "-") {
                                                                      //pesos[p] -=  param_aprend.ok[ok].val;
                                                                      pesos[p] -= p_ok;
                                                                 }

                                                            } else {

                                                                 //Errou
                                                                 if (param_aprend.nok[nok].type == "=") {
                                                                      //pesos[p] = param_aprend.nok[nok].val;
                                                                      pesos[p] = p_nok;
                                                                 } else if (param_aprend.nok[nok].type == "*") {
                                                                      //pesos[p] *= param_aprend.nok[nok].val;
                                                                      pesos[p] *= p_nok;
                                                                 } else if (param_aprend.nok[nok].type == "+") {
                                                                      //pesos[p] += param_aprend.nok[nok].val;
                                                                      pesos[p] += p_nok;
                                                                 } else if (param_aprend.nok[nok].type == "-") {
                                                                      //pesos[p] -= param_aprend.nok[nok].val;
                                                                      pesos[p] -= p_nok;
                                                                 }

                                                            }
                                                       }
                                                  }

                                                  //Ativação por pesos
                                                  let qtd_atv = 0;
                                                  for (let p = 0; p < param.qtd_tot_num_disp; p++) {
                                                       if (pesos[p] >= p_cort && pesos[p] <= p_cort + p_cort_max) {
                                                            ativos[p] = 1;
                                                            qtd_atv++;
                                                       } else {
                                                            ativos[p] = 0;
                                                       }
                                                  }

                                                  //Validação
                                                  if (qtd_atv <= param.max_num_result) {
                                                       let acertos = 0;
                                                       for (let k = 0; k < hist_list[idx_valid].length; k++) {
                                                            if (ativos[hist_list[idx_valid][k] - 1] == 1) {
                                                                 acertos++;
                                                            }
                                                       }
                                                       acertos_arr[acertos]++;

                                                       //Acertos
                                                       for (let j = 1; j <= num_sorteados; j++) {
                                                            let tot_acert = 0;
                                                            for (let m = j; m < num_sorteados; m++) {
                                                                 tot_acert += acertos_arr[m];
                                                            }

                                                            if (tot_acert / param.qtd_jogos_valid >= param.meta_eficiencia) {
                                                                 if (melhor_op[j].options[qtd_atv].eficiencia < tot_acert / param.qtd_jogos_valid) {
                                                                      console.log(JSON.stringify(melhor_op));
                                                                      melhor_op[j].options[qtd_atv].eficiencia = tot_acert / param.qtd_jogos_valid;
                                                                      melhor_op[j].options[qtd_atv].jogos_aprend = i;
                                                                      melhor_op[j].options[qtd_atv].ok = ok;
                                                                      melhor_op[j].options[qtd_atv].nok = nok;
                                                                      melhor_op[j].options[qtd_atv].p_ok = p_ok;
                                                                      melhor_op[j].options[qtd_atv].p_nok = p_nok;
                                                                      melhor_op[j].options[qtd_atv].p_cort = p_cort;
                                                                      melhor_op[j].options[qtd_atv].p_cort_max = p_cort_max;                                                                      
                                                                 }
                                                            }
                                                       }
                                                  }
                                             }
                                        }
                                   }
                              }
                         }
                    }
               }
          }
          console.log('melhor_op', JSON.stringify(melhor_op));*/
          // /*************** IA ***************/

          let result = {
               qtd_all: total_combin,
               total_comb: hist_list.length,
               numeros: [
                    {
                         "atraso": atraso.sort(function (a, b) { return b.atraso - a.atraso })
                    },
                    {
                         "atraso_graf": intervalo_atraso_graf
                    },
                    {
                         "intervalo_atraso": intervalo_atraso
                    },
                    {
                         "vezes_saiu": vezes_saiu.sort(function (a, b) { return b.vezes_saiu - a.vezes_saiu })
                    }
               ],
               combinacoes: [
                    {
                         "sequencias": sequencias
                    },
                    {
                         "sequencias_dire_max": sequencias_dire_max
                    },
                    {
                         "num_pares": num_pares
                    },
                    {
                         "qtd_fibonacci": qtd_fibonacci
                    },
                    {
                         "qtd_primos": qtd_primos
                    },
                    {
                         "qtd_linhas": qtd_linhas
                    },
                    {
                         "qtd_max_linhas": qtd_max_linhas
                    },
                    {
                         "qtd_colunas": qtd_colunas
                    },
                    {
                         "qtd_max_colunas": qtd_max_colunas
                    },
                    {
                         "menor_num": menor_num
                    },
                    {
                         "maior_num": maior_num
                    },
                    {
                         "qtd_quad_em_4_quad": qtd_quad_em_4_quad
                    },
                    {
                         "qtd_max_quad_em_4_quad": qtd_max_quad_em_4_quad
                    },
                    {
                         "qtd_rep_ultimo": qtd_rep_ultimo
                    },
                    {
                         "qtd_rep_2_ultimo": qtd_rep_2_ultimo
                    },
                    {
                         "qtd_rep_3_ultimo": qtd_rep_3_ultimo
                    },
                    {
                         "qtd_rep_4_ultimo": qtd_rep_4_ultimo
                    },
                    {
                         "qtd_rep_5_ultimo": qtd_rep_5_ultimo
                    }
               ]
          };

          postMessage({ result: result });

     });
}